import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { HxOrgSelectComponent, HxPagedListDirective } from 'hx-components';
import { HxUiLabelPipe, PagedList, WebkassaOrgAuthModel } from 'hx-services';
import { WebkassaCashboxService } from '@adm-web-app/services/webkassa-cashbox.service';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderSubtitleDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzCollapseComponent, NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { FormsModule } from '@angular/forms';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzThAddOnComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { DatePipe, NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

interface ListFilter {
  name: string;
  options: { label: string, value: string | number, checked?: boolean }[];
  isVisible: boolean;
  isActive: boolean;
  operator: 'and' | 'or';
}

@Component({
    selector: 'hc-webkassa-org-auth-list',
    templateUrl: './org-auth-list.component.html',
    styleUrls: ['./org-auth-list.component.less'],
  imports: [TranslocoDirective, NzAffixComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzCollapseComponent, NzCollapsePanelComponent, NzRowDirective, NzColDirective, HxOrgSelectComponent, FormsModule, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzThAddOnComponent, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, DatePipe, HxUiLabelPipe, TranslocoPipe]
})
export class WebkassaOrgAuthListComponent extends HxPagedListDirective<WebkassaOrgAuthModel> implements OnInit {
  filter: {
    orgId?: number;
  } = {};
  isLoading = {};

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    private webkassaCashboxService: WebkassaCashboxService,
  ) {
    super(router, aRoute);
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => {
        const asNumberFn = (name: string, def?: number) => paramMap.get(name) ? Number(paramMap.get(name)) : def;
        // const asBooleanFn = (name: string, def?: boolean) => paramMap.get(name) ? paramMap.get(name) === 'true' : def;
        this.filter.orgId = asNumberFn('orgId');
        super.load(paramMap);
      });
  }

  resetFilter(filter: ListFilter) {
    filter.options.forEach(op => op.checked = false);
  }

  applyFilters() {
    this.router.navigate([], {
      relativeTo: this.aRoute,
      queryParams: {
        orgId: this.filter.orgId,
      },
      queryParamsHandling: 'merge',
    });
  }

  protected loadList(): Promise<PagedList<WebkassaOrgAuthModel>> {
    return this.webkassaCashboxService.getOrgAuths({
      page: this.page,
      limit: this.limit,
      orgId: this.filter.orgId,
      sort: this.getSortParams(),
      includeDisabled: true,
    });
  }

  async remove(id: number) {
    await this.webkassaCashboxService.removeOrgAuth(id);
    await this.loadData();
  }
}
